/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Login_ButtonInputs */

const en_cv_check_login_button = /** @type {(inputs: Cv_Check_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

const de_cv_check_login_button = /** @type {(inputs: Cv_Check_Login_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

/**
* | output |
* | --- |
* | "Log in" |
*
* @param {Cv_Check_Login_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_login_button = /** @type {((inputs?: Cv_Check_Login_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Login_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_login_button(inputs)
	return en_cv_check_login_button(inputs)
});